import * as ImageManipulator from "expo-image-manipulator";
import { Alert } from "react-native";

import useCropperContext from "../context/cropper";

export const usePerformCrop = () => {
  const {
    accumulatedPan,
    imageBounds,
    imageScaleFactor,
    cropSize,
    setIsProcessing,
    imageData,
    setImageData,
    setEditingMode,
  } = useCropperContext();

  return async () => {
    try {
      const croppingBounds = {
        originX: Math.round(
          (accumulatedPan.x - imageBounds.x) * imageScaleFactor
        ),
        originY: Math.round(
          (accumulatedPan.y - imageBounds.y) * imageScaleFactor
        ),
        width: Math.round(cropSize.width * imageScaleFactor),
        height: Math.round(cropSize.height * imageScaleFactor),
      };
      setIsProcessing(true);
      const cropResult = await ImageManipulator.manipulateAsync(
        imageData.uri,
        [{ crop: croppingBounds }],
        { base64: true }
      );
      const { uri, width, height, base64 } = cropResult;
      setImageData({ uri, width, height, base64 });
      setIsProcessing(false);
      setEditingMode("operation-select");
    } catch (error) {
      setIsProcessing(false);
      Alert.alert("An error occurred while editing.");
    }
  };
};
